import { Skeleton } from '@/components/ui/skeleton';

const SkeletonCard = () => (
  <div className="flex h-full min-w-[260px] flex-col gap-4 rounded-lg bg-muted p-4">
    {/* Header — icon block + title + info icon */}
    <div className="flex items-center gap-2">
      <Skeleton className="h-8 w-8 shrink-0 rounded-md bg-foreground/15" />
      <Skeleton className="h-4 w-28 bg-foreground/15" />
      <div className="flex-1" />
      <Skeleton className="h-4 w-4 shrink-0 rounded-full bg-foreground/15" />
    </div>

    {/* Rows — label on the left, value on the right */}
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-3">
        <Skeleton className="h-3.5 w-20 bg-foreground/15" />
        <Skeleton className="h-3.5 w-16 bg-foreground/15" />
      </div>
      <div className="flex items-center justify-between gap-3">
        <Skeleton className="h-3.5 w-16 bg-foreground/15" />
        <Skeleton className="h-3.5 w-14 bg-foreground/15" />
      </div>
    </div>
  </div>
);

export const TimeOffBalancesSkeleton = () => {
  return (
    <div className="grid max-w-4xl auto-rows-fr grid-cols-1 gap-4 lg:grid-cols-3">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
};
